<template>
  <div class="add-bookList-container">
    <div class="global_popup_header">
      {{ title || $t("alertMsg.addGroup") }}
      <i @click="$store.commit('windowHandle')"></i>
    </div>
    <div class="global_popup_body addBookList-tree-main">
      <div class="addBookList-tree-list" v-bar>
        <div class="addBookList-tree-node">
          <transition-group name="fade">
            <tree-menu
              v-for="group in channles"
              v-if="group.name !== 'UNPUBLIC'"
              :key="group.id || group._id"
              :group="group"
              :depth="0"
              :isGroup="title === $t('content.books.selectGroup')"
              :defaultExpand="true"
              @nodeCheck="nodeCheck"
              @handleCheck="handleCheck"
            />
          </transition-group>
        </div>
      </div>
    </div>
    <div class="global_popup_footer">
      <button @click="confirm">{{ $t("commonMsg.confirm") }}</button>
    </div>
  </div>
</template>

<script>
import treeMenu from "./treeMenu";
export default {
  props: {
    channles: Array,
    title: {
      type: String
    }
  },
  components: {
    treeMenu
  },
  data() {
    return {
      group: null
    };
  },
  methods: {
    nodeCheck(group) {
      this.group = group;
    },
    handleCheck() {},
    confirm() {
      if (!this.group || !this.group.check) {
        this.$t("content.books.selectGroup") === this.title
          ? this.elMsg(this.$t("content.books.selectGroup"), "warning")
          : this.elMsg(this.$t("content.books.selectClassify"), "warning");
        return;
      }
      this.$emit("confirmEvn", this.group);
      this.$store.commit("windowHandle");
    }
  }
};
</script>

<style lang="scss" scoped>
.add-bookList-container {
  @include globalPopup(500px, 500px);
  .addBookList-tree-main {
    display: flex;
    overflow: hidden;
    margin-bottom: 20px;
    > .addBookList-tree-list {
      width: 100%;
      flex: 1;
      overflow: hidden;
      border: 1px solid #ccc;
    }
  }
}
</style>
